module.exports = __webpack_public_path__ + "img/slide3.5bddc543.png";